import {AlertIcon, CopilotIcon} from '@primer/octicons-react'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {Button, Spinner} from '@primer/react'
import type {Ref} from 'react'

type FailureAnalysisButtonStatus = 'loading' | 'ready' | 'error'

export function FailureAnalysisButton({
  status,
  onClick,
  ref,
}: {
  status: FailureAnalysisButtonStatus
  onClick: () => void
  ref?: Ref<HTMLButtonElement>
}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()
  const config = buttonConfig[status]
  const handleClick = () => {
    sendClickAnalyticsEvent({
      category: 'CI_ANALYSIS',
      action: 'ci_analysis:open_failure_analysis',
      surface: 'pull_request_panel',
      status,
    })
    onClick()
  }

  return (
    <Button ref={ref} size="small" onClick={handleClick} leadingVisual={config.leadingVisual}>
      {config.label}
    </Button>
  )
}

const buttonConfig: Record<FailureAnalysisButtonStatus, {leadingVisual: React.ComponentType; label: React.ReactNode}> =
  {
    loading: {
      leadingVisual: () => <Spinner size="small" />,
      label: (
        <>
          <strong>Copilot</strong> is analyzing CI failures
        </>
      ),
    },
    ready: {
      leadingVisual: CopilotIcon,
      label: 'View failure analysis',
    },
    error: {
      leadingVisual: () => <AlertIcon className="fgColor-attention" />,
      label: 'Failure analysis unavailable',
    },
  }
